import { Action } from '@ngrx/store';
import { VotePostInput } from '../../../shared/data/inputs/vote-post.input';
import { PostActionResultModel } from '../../../shared/data/models/post-action-result.model';
import { CreateCommentMutationInput } from '../../../shared/data/inputs/create-comment-mutation.input';
import { CommentModel } from '../../../shared/data/models/comment.model';
import { LightPostModel } from '../../../shared/data/models/light-post.model';
import { NewPostMutationInput } from '../../../shared/data/inputs/new-post-mutation.input';
import { PostQueryInput } from '../../../shared/data/inputs/post-query.input';
import { PostErrorInput } from '../../../shared/data/inputs/post-error.input';
import { GetPostCommentsQueryInput } from '../../../shared/data/inputs/get-post-comments-query.input';
import { PostCommentModel } from '../../../shared/data/models/post-comment.model';
import { PostInput } from '../../../shared/data/inputs/post.input';
import { CommentErrorInput } from '../../../shared/data/inputs/comment-error.input';
import { PostCommentInput } from '../../../shared/data/inputs/post-comment.input';
import { CommentPostInput } from '../../../shared/data/inputs/comment-post.input';
import { DeletePostInput } from '../../../shared/data/inputs/delete-post.input';
import { SocialUserModel } from '../../../shared/data/models/social-user.model';
import { TimelineSubscriptionModel } from '../../../shared/data/models/timeline-subscription.model';
import { TimelineSubscriptionInput } from '../../../shared/data/inputs/timeline-subscription.input';
import { VoteCommentErrorInput } from '../../../shared/data/inputs/vote-comment-error.input';
import { VoteCommentSuccessInput } from '../../../shared/data/inputs/vote-comment-success.input';
import { VoteCommentInput } from '../../../shared/data/inputs/vote-comment.input';
import { CastPollVoteInput } from '../../../shared/data/inputs/cast-poll-vote.input';
import { CreateLinkInput } from '../../../shared/data/inputs/create-link.input';
import { UploadFileInput } from '../../../shared/data/inputs/upload-file.input';
import { UploadFileModel } from '../../../shared/data/models/upload-file.model';
import { UserPostInput } from '../../../shared/data/inputs/user-post.input';
import { FavoritePostInput } from '../../../shared/data/inputs/favorite-post.input';
import { PostPayloadInput } from '../../../shared/data/inputs/post-payload.input';
import { LightPostWithCommentsModel } from '../../../shared/data/models/light-post-with-comments.model';
import { SearchPostInput } from '../../../shared/data/inputs/search-post.input';
import { CreateReplyMessageInput } from '../inputs/create-reply-message.input';
import { CreateReplyCommentSuccessInput } from '../inputs/create-reply-Comment-success.input';
import { CreateReplyCommentErrorInput } from '../inputs/create-reply-comment-error.input';
import { ShowReplyCommentInput } from '../inputs/show-reply-comment.input';
import { PostCommentReplyInput } from '../inputs/post-comment-reply.input';
import { ReplyCommentsInput } from '../inputs/reply-comments.input';
import { ReplyCommentErrorInput } from '../inputs/reply-comment-error.input';
import { VoteReplyCommentInput } from '../inputs/vote-reply-comment.input';
import { DeleteReplyCommentErrorInput } from '../inputs/delete-reply-comment-error.input';
import { FileItem } from 'ng2-file-upload/file-upload/file-item.class';
import { FileUploadModel } from '../../../shared/file-upload.model';

export enum HomeActionTypes {
  // upload file
  UploadFile = '[Home] Upload File',
  UploadFileSuccess = '[Home] Upload File Success',
  UploadFileError = '[Home] Upload File Error',

  PostFormType = '[Home] post form type',
  PollFormType = '[Home] poll form type',
  ArticleFormType = '[Home] article form type',
  AddUploadFile = '[Home] Add Upload File',
  RemoveUploadFile = '[Home] Remove Upload File',

  AddVideoUploadFile = '[Home] Add Video Upload File',
  RemoveVideoUploadFile = '[Home] Remove Video Upload File',

  LoadTopFeed = '[Home] Load Top Feeds',
  LoadPostSuccess = '[Home] Load Posts Success',
  LoadPostError = '[Home] Load Posts Error',

  // create post
  CreateNormalPost = '[Home] Create Normal Post',
  CreateNormalPostSuccess = '[Home] Create Normal Post Success',
  CreateNormalPostError = '[Home] Create Normal Post Error',

  // create echo
  CreateEchoPost = '[Home] Create Echo Post',
  CreateEchoPostSuccess = '[Home] Create Echo Post Success',
  JustEchoSuccess = '[Home] Just Echo Post Success',
  CreateEchoPostError = '[Home] Create Echo Post Error',

  CreateComment = '[Home] create comment',
  CreateCommentSuccess = '[Home] create comment Success',
  CreateCommentError = '[Home] create comment Error',

  UpVotePost = '[Home] up vote post logic',
  DownVotePost = '[Home] down vote post  logic',
  UnVotePost = '[Home] un vote post  logic',
  VotePostSuccess = '[Home] vote success',
  VotePostError = '[Home] error',

  UpVoteComment = '[Home] up vote comment logic',
  DownVoteComment = '[Home] down vote comment logic',
  UnVoteComment = '[Home] un vote comment logic',
  VoteCommentSuccess = '[Home] vote comment success',
  VoteCommentError = '[Home] vote comment error',

  ShowComments = '[Home] Show comments',
  HideComments = '[Home] Hide comments',

  ShowCommentsError = '[Home] Show comments error',
  ShowCommentsSuccess = '[Home] Show comments success',

  TimelineSubscribe = '[Home] subscribe to timeline',
  TimelineSubscribeSuccess = '[Home] subscribed to timeline successfully',
  TimelineSubscribeError = '[Home] an error when subscribing to timeline',

  // load more comments
  LoadMoreComment = '[Home] Load more comment',
  LoadMoreCommentSuccess = '[Home] Load more comment success',
  LoadMoreCommentError = '[Home] Load more comment error',

  // reply comments
  ShowReplyComment = '[Home] Show reply comments',
  HideReplyComment = '[Home] Hide reply comments',

  ShowReplyCommentSuccess = '[Home] Show reply comments success',
  ShowReplyCommentError = '[Home] Show reply comments error',

  LoadMoreReplyComment = '[Home] Load More Reply Comments',
  LoadMoreReplyCommentSuccess = '[Home] Load More Reply Comments success',
  LoadMoreReplyCommentError = '[Home] Load More Reply Comments error',

  CreateReplyComment = '[Home] create reply comment',
  CreateReplyCommentSuccess = '[Home] create reply comment success',
  CreateReplyCommentError = '[Home] create reply comment error',

  UpVoteReplyComment = '[Home] upvote Reply comment',
  DownVoteReplyComment = '[Home] downvote Reply comment',
  UnVoteReplyComment = '[Home] unvote Reply comment',

  VoteReplyCommentSuccess = '[Home] VoteReplyCommentSuccess',
  VoteReplyCommentError = '[Home] VoteReplyCommentError',

  DeleteReplyComment = '[Home] DeleteReplyComment',
  DeleteReplyCommentSuccess = '[Home] DeleteReplyCommentSuccess',
  DeleteReplyCommentError = '[Home] DeleteReplyCommentError',

  // profile actions

  LoadUserProfile = '[Profile] Load User Profile',
  LoadUserProfileSuccess = '[Profile] Load User Profile Success',
  LoadUserProfileError = '[Profile] Load User Profile Error',

  // delete post
  DeletePost = '[Home] Delete your own post',
  DeletePostSuccess = '[Home] Delete your own post success',
  DeletePostError = '[Home] Delete your own post error',

  // delete comments
  DeleteComment = '[Home] Delete your own comment',
  DeleteCommentSuccess = '[Home] Delete your own comment Success',
  DeleteCommentError = '[Home] Delete your own comment error',

  // load more timeline content post - any type
  LoadMorePost = '[Home] Load More Post',
  LoadMorePostSuccess = '[Home] Load More Post Success',
  LoadMorePostError = '[Home] Load More Post Error',

  // favorite post

  FavoritePost = '[Social] Favorite Post',
  UnFavoritePost = '[Social] Un Favorite Post',
  FavoritePostSuccess = '[Social] Favorite Post Success',
  FavoritePostError = '[Social] Favorite Post Error',

  // vote for post
  VotePostPoll = '[Social] Vote Post Poll',
  VotePostPollSuccess = '[Social] Vote Post Poll Success',
  VotePostPollError = '[Social] Vote Post Poll Error',

  // user level posts
  LoadUserPost = '[Home] Load User Posts',
  LoadMoreUserPost = '[Home] Load More User Posts',
  LoadUserFavorite = '[Home] Load User Favorite',
  LoadMoreUserFavorite = '[Home] Load More User Favorite',

  // expanded post
  LoadExpandedPost = '[Home] Load Expanded Post ',
  LoadExpandedPostSuccess = '[Home]  Load Expanded Post Success',

  // hashtags
  SearchPosts = '[Search] search post',
  SearchMorePosts = '[Search] search more post'
}

export class PostFormType implements Action {
  readonly type = HomeActionTypes.PostFormType;
}

export class UploadFile implements Action {
  readonly type = HomeActionTypes.UploadFile;

  constructor(
    public payload: {
      input: CreateLinkInput;
      file: File;
    }
  ) {}
}

export class UploadFileSuccess implements Action {
  readonly type = HomeActionTypes.UploadFileSuccess;

  constructor(public payload: UploadFileInput) {}
}

export class UploadFileError implements Action {
  readonly type = HomeActionTypes.UploadFileError;

  // fileName,
  constructor(public payload: string) {}
}

export class PollFormType implements Action {
  readonly type = HomeActionTypes.PollFormType;
}

export class ArticleFormType implements Action {
  readonly type = HomeActionTypes.ArticleFormType;
}

export class AddUploadFile implements Action {
  readonly type = HomeActionTypes.AddUploadFile;

  constructor(public payload: UploadFileModel) {}
}

export class RemoveUploadFile implements Action {
  readonly type = HomeActionTypes.RemoveUploadFile;

  constructor(public payload: number) {}
}

export class AddVideoUploadFile implements Action {
  readonly type = HomeActionTypes.AddVideoUploadFile;

  constructor(public payload: FileUploadModel) {}
}

export class RemoveVideoUploadFile implements Action {
  readonly type = HomeActionTypes.RemoveVideoUploadFile;

  constructor(public payload: string) {}
}

export class LoadMoreComment implements Action {
  readonly type = HomeActionTypes.LoadMoreComment;

  constructor(public payload: GetPostCommentsQueryInput) {}
}

export class LoadMoreCommentSuccess implements Action {
  readonly type = HomeActionTypes.LoadMoreCommentSuccess;

  constructor(public payload: PostCommentModel) {}
}

export class LoadMoreCommentError implements Action {
  readonly type = HomeActionTypes.LoadMoreCommentError;

  constructor(public payload: PostErrorInput) {}
}

export class ShowComments implements Action {
  readonly type = HomeActionTypes.ShowComments;

  // postId
  constructor(public payload: GetPostCommentsQueryInput) {}
}

export class HideComments implements Action {
  readonly type = HomeActionTypes.HideComments;

  constructor(public payload: string) {}
}

export class ShowCommentsSuccess implements Action {
  readonly type = HomeActionTypes.ShowCommentsSuccess;

  public constructor(public payload: PostCommentModel) {}
}

export class ShowCommentsError implements Action {
  readonly type = HomeActionTypes.ShowCommentsError;

  public constructor(public payload: PostErrorInput) {}
}

export class LoadTopFeed implements Action {
  readonly type = HomeActionTypes.LoadTopFeed;

  constructor(public payload: PostQueryInput) {}
}

export class LoadPostSuccess implements Action {
  readonly type = HomeActionTypes.LoadPostSuccess;

  constructor(public payload: PostPayloadInput) {}
}

export class LoadPostError implements Action {
  readonly type = HomeActionTypes.LoadPostError;

  constructor(public payload: string) {}
}

export class CreateNormalPost implements Action {
  readonly type = HomeActionTypes.CreateNormalPost;

  constructor(public payload: NewPostMutationInput) {}
}

export class CreateNormalPostSuccess implements Action {
  readonly type = HomeActionTypes.CreateNormalPostSuccess;

  constructor(public payload: LightPostModel) {}
}

export class CreateNormalPostError implements Action {
  readonly type = HomeActionTypes.CreateNormalPostError;

  constructor(public payload: string) {}
}

// create echo post
export class CreateEchoPost implements Action {
  readonly type = HomeActionTypes.CreateEchoPost;

  constructor(
    public payload: { input: NewPostMutationInput; showOnFeed: boolean }
  ) {}
}

export class CreateEchoPostSuccess implements Action {
  readonly type = HomeActionTypes.CreateEchoPostSuccess;

  constructor(public payload: LightPostModel) {}
}

export class JustEchoSuccess implements Action {
  readonly type = HomeActionTypes.JustEchoSuccess;
}

export class CreateEchoPostError implements Action {
  readonly type = HomeActionTypes.CreateEchoPostError;

  constructor(public payload: string) {}
}

// create comment
export class CreateComment implements Action {
  readonly type = HomeActionTypes.CreateComment;

  constructor(public payload: CreateCommentMutationInput) {}
}

export class CreateCommentSuccess implements Action {
  readonly type = HomeActionTypes.CreateCommentSuccess;

  constructor(
    public payload: {
      postId: string;
      comment: CommentModel;
    }
  ) {}
}

export class CreateCommentError implements Action {
  readonly type = HomeActionTypes.CreateCommentError;

  constructor(public payload: string) {}
}

// upvote post
export class UpVotePost implements Action {
  readonly type = HomeActionTypes.UpVotePost;

  constructor(public payload: VotePostInput) {}
}

export class DownVotePost implements Action {
  readonly type = HomeActionTypes.DownVotePost;

  constructor(public payload: VotePostInput) {}
}

export class UnVotePost implements Action {
  readonly type = HomeActionTypes.UnVotePost;

  constructor(public payload: VotePostInput) {}
}

export class VotePostSuccess implements Action {
  readonly type = HomeActionTypes.VotePostSuccess;

  constructor(public payload: PostActionResultModel) {}
}

export class VotePostError implements Action {
  readonly type = HomeActionTypes.VotePostError;

  constructor(public payload: PostErrorInput) {}
}

// comment votes
export class UpVoteComment implements Action {
  readonly type = HomeActionTypes.UpVoteComment;

  constructor(public payload: VoteCommentInput) {}
}

export class DownVoteComment implements Action {
  readonly type = HomeActionTypes.DownVoteComment;

  constructor(public payload: VoteCommentInput) {}
}

export class UnVoteComment implements Action {
  readonly type = HomeActionTypes.UnVoteComment;

  constructor(public payload: VoteCommentInput) {}
}

export class VoteCommentSuccess implements Action {
  readonly type = HomeActionTypes.VoteCommentSuccess;

  constructor(public payload: VoteCommentSuccessInput) {}
}

export class VoteCommentError implements Action {
  readonly type = HomeActionTypes.VoteCommentError;

  constructor(public payload: VoteCommentErrorInput) {}
}

// timeline subscription actions
export class TimelineSubscribe implements Action {
  readonly type = HomeActionTypes.TimelineSubscribe;

  constructor(public payload: TimelineSubscriptionInput) {}
}

export class TimelineSubscribeSuccess implements Action {
  readonly type = HomeActionTypes.TimelineSubscribeSuccess;

  constructor(public payload: TimelineSubscriptionModel) {}
}

export class TimelineSubscribeError implements Action {
  readonly type = HomeActionTypes.TimelineSubscribeError;

  constructor(public payload: string) {}
}

/*
 *
 * profile actions
 * */
export class LoadUserProfile implements Action {
  readonly type = HomeActionTypes.LoadUserProfile;

  constructor(public payload: string) {}
}

export class LoadUserProfileSuccess implements Action {
  readonly type = HomeActionTypes.LoadUserProfileSuccess;

  constructor(public payload: SocialUserModel) {}
}

export class LoadUserProfileError implements Action {
  readonly type = HomeActionTypes.LoadUserProfileError;

  constructor(public payload: string) {}
}

// delete post actions
export class DeletePost implements Action {
  readonly type = HomeActionTypes.DeletePost;

  constructor(public payload: PostInput) {}
}

export class DeletePostSuccess implements Action {
  readonly type = HomeActionTypes.DeletePostSuccess;

  constructor(public payload: DeletePostInput) {}
}

export class DeletePostError implements Action {
  readonly type = HomeActionTypes.DeletePostError;

  constructor(public payload: PostErrorInput) {}
}

// delete comment
export class DeleteComment implements Action {
  readonly type = HomeActionTypes.DeleteComment;

  constructor(public payload: CommentPostInput) {}
}

export class DeleteCommentSuccess implements Action {
  readonly type = HomeActionTypes.DeleteCommentSuccess;

  constructor(public payload: PostCommentInput) {}
}

export class DeleteCommentError implements Action {
  readonly type = HomeActionTypes.DeleteCommentError;

  constructor(public payload: CommentErrorInput) {}
}

// load more content
export class LoadMoreTimeline implements Action {
  readonly type = HomeActionTypes.LoadMorePost;

  constructor(public payload: PostQueryInput) {}
}

export class LoadMorePostSuccess implements Action {
  readonly type = HomeActionTypes.LoadMorePostSuccess;

  constructor(public payload: PostPayloadInput) {}
}

export class LoadMorePostError implements Action {
  readonly type = HomeActionTypes.LoadMorePostError;

  constructor(public payload: string) {}
}

// favorite post
export class FavoritePost implements Action {
  readonly type = HomeActionTypes.FavoritePost;

  constructor(public payload: PostInput) {}
}

export class UnFavoritePost implements Action {
  readonly type = HomeActionTypes.UnFavoritePost;

  constructor(public payload: PostInput) {}
}

export class FavoritePostSuccess implements Action {
  readonly type = HomeActionTypes.FavoritePostSuccess;

  constructor(public payload: LightPostModel) {}
}

export class FavoritePostError implements Action {
  readonly type = HomeActionTypes.FavoritePostError;

  constructor(public payload: PostErrorInput) {}
}

// vote poll
export class VotePostPoll implements Action {
  readonly type = HomeActionTypes.VotePostPoll;

  constructor(public payload: CastPollVoteInput) {}
}

export class VotePostPollSuccess implements Action {
  readonly type = HomeActionTypes.VotePostPollSuccess;

  constructor(public payload: LightPostModel) {}
}

export class VotePostPollError implements Action {
  readonly type = HomeActionTypes.VotePostPollError;

  constructor(public payload: PostErrorInput) {}
}

// user post level actions
export class LoadUserPost implements Action {
  readonly type = HomeActionTypes.LoadUserPost;

  constructor(public payload: UserPostInput) {}
}

export class LoadMoreUserPost implements Action {
  readonly type = HomeActionTypes.LoadMoreUserPost;

  constructor(public payload: UserPostInput) {}
}

export class LoadUserFavorite implements Action {
  readonly type = HomeActionTypes.LoadUserFavorite;

  constructor(public payload: FavoritePostInput) {}
}

export class LoadMoreUserFavorite implements Action {
  readonly type = HomeActionTypes.LoadMoreUserFavorite;

  constructor(public payload: FavoritePostInput) {}
}

export class LoadExpandedPost implements Action {
  readonly type = HomeActionTypes.LoadExpandedPost;

  constructor(public payload: GetPostCommentsQueryInput) {}
}

export class LoadExpandedPostSuccess implements Action {
  readonly type = HomeActionTypes.LoadExpandedPostSuccess;

  constructor(public payload: LightPostWithCommentsModel) {}
}

export class SearchPosts implements Action {
  readonly type = HomeActionTypes.SearchPosts;

  constructor(public payload: SearchPostInput) {}
}

export class SearchMorePosts implements Action {
  readonly type = HomeActionTypes.SearchMorePosts;

  constructor(public payload: SearchPostInput) {}
}

// reply part

export class ShowReplyComment implements Action {
  readonly type = HomeActionTypes.ShowReplyComment;

  constructor(public payload: ShowReplyCommentInput) {}
}

export class HideReplyComment implements Action {
  readonly type = HomeActionTypes.HideReplyComment;

  constructor(public payload: PostCommentReplyInput) {}
}

export class ShowReplyCommentSuccess implements Action {
  readonly type = HomeActionTypes.ShowReplyCommentSuccess;

  constructor(public payload: ReplyCommentsInput) {}
}

export class ShowReplyCommentError implements Action {
  readonly type = HomeActionTypes.ShowReplyCommentError;

  constructor(public payload: ReplyCommentErrorInput) {}
}

// create reply comment
export class CreateReplyComment implements Action {
  readonly type = HomeActionTypes.CreateReplyComment;

  constructor(public input: CreateReplyMessageInput) {}
}

export class CreateReplyCommentSuccess implements Action {
  readonly type = HomeActionTypes.CreateReplyCommentSuccess;

  constructor(public input: CreateReplyCommentSuccessInput) {}
}

export class CreateReplyCommentError implements Action {
  readonly type = HomeActionTypes.CreateReplyCommentError;

  constructor(public input: CreateReplyCommentErrorInput) {}
}

export class LoadMoreReplyComment implements Action {
  readonly type = HomeActionTypes.LoadMoreReplyComment;

  constructor(public payload: PostCommentReplyInput) {}
}

export class LoadMoreReplyCommentSuccess implements Action {
  readonly type = HomeActionTypes.LoadMoreReplyCommentSuccess;

  constructor(public payload: ReplyCommentsInput) {}
}

export class UpVoteReplyComment implements Action {
  readonly type = HomeActionTypes.UpVoteReplyComment;

  constructor(public payload: PostCommentReplyInput) {}
}

export class DownVoteReplyComment implements Action {
  readonly type = HomeActionTypes.DownVoteReplyComment;

  constructor(public payload: PostCommentReplyInput) {}
}

export class UnVoteReplyComment implements Action {
  readonly type = HomeActionTypes.UnVoteReplyComment;

  constructor(public payload: PostCommentReplyInput) {}
}

export class VoteReplyCommentSuccess implements Action {
  readonly type = HomeActionTypes.VoteReplyCommentSuccess;

  constructor(public payload: VoteReplyCommentInput) {}
}

export class VoteReplyCommentError implements Action {
  readonly type = HomeActionTypes.VoteReplyCommentError;

  constructor(public payload: CreateReplyCommentErrorInput) {}
}

export class DeleteReplyComment implements Action {
  readonly type = HomeActionTypes.DeleteReplyComment;

  constructor(public payload: PostCommentReplyInput) {}
}

export class DeleteReplyCommentSuccess implements Action {
  readonly type = HomeActionTypes.DeleteReplyCommentSuccess;

  constructor(public payload: PostCommentReplyInput) {}
}

export class DeleteReplyCommentError implements Action {
  readonly type = HomeActionTypes.DeleteReplyCommentError;

  constructor(public payload: DeleteReplyCommentErrorInput) {}
}

export type PostAction =
  | PostFormType
  | UploadFile
  | UploadFileSuccess
  | UploadFileError
  | PollFormType
  | ArticleFormType
  | ShowComments
  | HideComments
  | ShowCommentsSuccess
  | ShowCommentsError
  | LoadTopFeed
  | LoadPostSuccess
  | LoadPostError
  | CreateNormalPost
  | CreateNormalPostSuccess
  | CreateNormalPostError
  | CreateEchoPost
  | CreateEchoPostSuccess
  | JustEchoSuccess
  | CreateEchoPostError
  | CreateComment
  | CreateCommentSuccess
  | CreateCommentError
  | UpVotePost
  | DownVotePost
  | VotePostSuccess
  | VotePostError
  | UpVoteComment
  | DownVoteComment
  | UnVoteComment
  | UnVotePost
  | VoteCommentSuccess
  | VoteCommentError
  | TimelineSubscribe
  | TimelineSubscribeSuccess
  | TimelineSubscribeError
  | LoadMoreComment
  | LoadMoreCommentSuccess
  | LoadMoreCommentError
  | LoadUserProfile
  | LoadUserProfileSuccess
  | LoadUserProfileError
  | DeletePost
  | DeletePostSuccess
  | DeletePostError
  | DeleteComment
  | DeleteCommentSuccess
  | DeleteCommentError
  | LoadMoreTimeline
  | LoadMorePostSuccess
  | LoadMorePostError
  | AddUploadFile
  | RemoveUploadFile
  | AddVideoUploadFile
  | RemoveVideoUploadFile
  | FavoritePost
  | UnFavoritePost
  | FavoritePostSuccess
  | FavoritePostError
  | VotePostPoll
  | VotePostPollError
  | VotePostPollSuccess
  | LoadUserPost
  | LoadUserFavorite
  | LoadMoreUserPost
  | LoadMoreUserFavorite
  | LoadExpandedPost
  | LoadExpandedPostSuccess
  | SearchPosts
  | SearchMorePosts
  | ShowReplyComment
  | HideReplyComment
  | ShowReplyCommentSuccess
  | ShowReplyCommentError
  | CreateReplyComment
  | CreateReplyCommentSuccess
  | CreateReplyCommentError
  | LoadMoreReplyComment
  | LoadMoreReplyCommentSuccess
  | UpVoteReplyComment
  | DownVoteReplyComment
  | UnVoteReplyComment
  | VoteReplyCommentSuccess
  | VoteReplyCommentError
  | DeleteReplyComment
  | DeleteReplyCommentSuccess
  | DeleteReplyCommentError;
